module.exports = "/_next/static/images/error-404-6031528d8e7b7422e9caa92ffc1c2131.svg";